let forms = {

    fileInputs: '',
    form: '',

    init: function() {
        forms.fileInputs = document.querySelectorAll('.input-file');
        forms.form = document.querySelectorAll('#offres-form form')[0];

        [...forms.fileInputs].forEach((input) => {
            let label = input.nextElementSibling;
            input.addEventListener('change', (e) => {
                let fileName = '';
                if( this.files && this.files.length > 1 ) {
                    fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
                } else {
                    fileName = e.target.value.split("\\").pop();
                }

                label.classList.toggle('filled', fileName !== '');
                label.classList.toggle('valid', fileName !== '');

                if( fileName ) {
                    label.innerHTML = fileName;
                } else {
                    label.innerHTML = "";
                }
            })
        })
    }
};

document.addEventListener('DOMContentLoaded', forms.init);